import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import { getStatus } from "src/utils/getStatus";
import Iconify from "../iconify";

export default function NewsTable(props) {
	const { news, onMenuOpen } = props;

	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="news table">
				<TableHead>
					<TableRow>
						<TableCell>ID</TableCell>
						<TableCell>Title</TableCell>
						<TableCell>Category</TableCell>
						<TableCell>Created At</TableCell>
						<TableCell>Status</TableCell>
						<TableCell></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{news?.map((row, index) => (
						<TableRow
							key={index}
							sx={{
								"&:last-child td, &:last-child th": { border: 0 },
							}}
						>
							<TableCell component="th" scope="row">
								{row.id}
							</TableCell>
							<TableCell component="th" scope="row">
								<Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
									{row.title}
								</Typography>
							</TableCell>
							<TableCell component="th" scope="row">
								{row.categoryName}
							</TableCell>
							<TableCell component="th" scope="row">
								{fDateTime(row.createdAt)}
							</TableCell>
							<TableCell component="th" scope="row">
								{getStatus(row?.status ?? 0)}
							</TableCell>
							<TableCell align="right">
								<IconButton size="large" color="inherit" onClick={onMenuOpen} id={row.id}>
									<Iconify icon={"eva:more-vertical-fill"} />
								</IconButton>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
